import React from "react";
import "react-router-dom";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footerV2">
      <div className="footerV2Container">
        {/* Company */}
        <div className="footerV2Col">
          <h2 className="footerV2Logo">
            <span className="text-gradient">LifeTime Infotech</span>
          </h2>

          <p className="footerV2Text">
            LifeTime Infotech is highly committed to delivering quality,
            cost-effective IT solutions that empower businesses with innovative
            technologies.
          </p>

          <div className="footerV2Social">
            <a href="#">
              <i className="bi bi-facebook"></i>
            </a>
            <a href="#">
              <i className="bi bi-instagram"></i>
            </a>
            <a href="#">
              <i className="bi bi-linkedin"></i>
            </a>
            <a href="#">
              <i className="bi bi-twitter-x"></i>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footerV2Col">
          <h3>Quick Links</h3>

          <ul className="footerV2Links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/portfolio">Portfolio</Link>
            </li>
            <li>
              <Link to="/contact1">Contact Us</Link>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div className="footerV2Col">
          <h3>Services</h3>

          <ul className="footerV2Links">
            <li>
              <Link to="/services">Web Development</Link>
            </li>
            <li>
              <Link to="/services">Mobile App Development</Link>
            </li>
            <li>
              <Link to="/services">UI / UX Design</Link>
            </li>
            <li>
              <Link to="/services">E-Commerce</Link>
            </li>
            <li>
              <Link to="/services">Digital Marketing</Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footerV2Col">
          <h3>Contact Us</h3>

          <div className="footerV2Contact">
            <p>
              <i className="bi bi-geo-alt-fill"></i>
              Shop-17, UP GR Floor, Ranuja Complex, Nr- Riddhi Siddhi School,
              Vallabhacharya Road, Ashvani Kumar, Surat-395008 Gujarat, India
            </p>

            <p>
              <i className="bi bi-telephone-fill"></i>
              (+91) 99096 14445
            </p>

            <p>
              <i className="bi bi-envelope-fill"></i>
              lifetimeinfotech@gmail.com
            </p>
          </div>

          <Link to="/contact1" className="footerV2Btn">
            Get In Touch
          </Link>
        </div>
      </div>

      <div className="footerV2Bottom">
        © 2026 LifeTime Infotech. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
